// src/config.js
// Backend API URL Configuration
// - Local development: uses localhost:5000
// - Production (crackers.smartgonext.com): uses live backend
export const API_BASE_URL = 
  window.location.hostname === "localhost" || 
  window.location.hostname === "127.0.0.1" || 
  /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname)
    ? `http://${window.location.hostname}:5000`
    : "https://crackers-backend.smartgonext.com";